
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"24","viewBox":"0 0 512 512","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M251.988 512h-40c-19.851 0-36-16.149-36-36V228c0-19.851 16.149-36 36-36h40c19.851 0 36 16.149 36 36v248c0 19.851-16.15 36-36 36zm-40-288c-2.206 0-4 1.794-4 4v248c0 2.206 1.794 4 4 4h40c2.206 0 4-1.794 4-4V228c0-2.206-1.794-4-4-4zM99.988 512h-40c-19.851 0-36-16.149-36-36V308c0-19.851 16.149-36 36-36h40c19.851 0 36 16.149 36 36v168c0 19.851-16.15 36-36 36zm-40-208c-2.206 0-4 1.794-4 4v168c0 2.206 1.794 4 4 4h40c2.206 0 4-1.794 4-4V308c0-2.206-1.794-4-4-4zM403.988 512h-40c-19.851 0-36-16.149-36-36V144h-21.98c-10.276 0-19.328-5.8-23.622-15.136s-2.807-19.982 3.881-27.785c.076-.089.154-.178.232-.265l85.573-95.492a16 16 0 0123.832 0l85.573 95.492c.079.087.156.176.232.265 6.688 7.802 8.175 18.449 3.881 27.785S472.244 144 461.968 144h-21.98v332c0 19.851-16.15 36-36 36zm-84.544-400h24.544c8.836 0 16 7.164 16 16v348c0 2.206 1.794 4 4 4h40c2.206 0 4-1.794 4-4V128c0-8.836 7.164-16 16-16h24.544l-64.544-72.025z"}})])
          )
        }
      }
    